document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.patouno-sticky-atc').forEach(setupStickyAtc);
});

function setupStickyAtc(bar) {
  const targetId = bar.dataset.targetButton;
  const targetButton = targetId && document.getElementById(targetId);
  if (!targetButton) return;

  const stickyButton = bar.querySelector('.patouno-sticky-atc__button');
  const stickyPrice = bar.querySelector('.patouno-sticky-atc__price');
  const targetLabel = targetButton.querySelector('span');
  const priceContainer = document.getElementById(bar.dataset.priceContainer || '');

  const syncState = () => {
    stickyButton.disabled = targetButton.disabled;
    if (targetLabel) stickyButton.textContent = targetLabel.textContent.trim();
  };

  const syncPrice = () => {
    if (!priceContainer || !stickyPrice) return;
    const visibleBlock = [...priceContainer.querySelectorAll('.price__regular, .price__sale')].find(
      (el) => getComputedStyle(el).display !== 'none'
    );
    const items = visibleBlock?.querySelectorAll('.price-item');
    const priceText = items?.length ? items[items.length - 1].textContent.trim() : null;
    if (priceText) stickyPrice.textContent = priceText;
  };

  syncState();
  syncPrice();

  new MutationObserver(syncState).observe(targetButton, {
    attributes: true,
    attributeFilter: ['disabled'],
    characterData: true,
    childList: true,
    subtree: true,
  });

  if (priceContainer) {
    new MutationObserver(syncPrice).observe(priceContainer, {
      characterData: true,
      childList: true,
      subtree: true,
    });
  }

  new IntersectionObserver(
    ([entry]) => {
      const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      bar.hidden = !scrolledPast;
    },
    { threshold: 0 }
  ).observe(targetButton);

  stickyButton.addEventListener('click', () => {
    targetButton.scrollIntoView({ behavior: 'smooth', block: 'center' });
    targetButton.focus({ preventScroll: true });
  });
}
